/**
 *
 * @component 个人中心/我的方案/项目管理——项目卡片组件
 *
 **/
import { Dropdown, Menu, Image, Form } from 'antd';
import React from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import useCalcAmount from '@/utils/customHooks/useCalcAmount1.4';
import dayjs from 'dayjs';
import './ProjectCard.scss';

function ProjectCard(props) {
    const {
        source = {},
        clickName,
        hasMenu = true,
        toPay,
        rename,
        remove,
        onExit,
    } = props;

    const [periodChange, paymentAmount] = useCalcAmount();

    useEffect(() => {
        periodChange(source.payCode?.period || 1);
    }, [source.payCode]);

    function handleClickMenu({ key }) {
        [rename, remove, onExit][key](source);
    }
    const { Item } = Menu;

    const menu = (
        <Menu onClick={handleClickMenu}>
            <Item key={0} disabled={source.isCreate === 2}>
                {intl.get('base.rename')}
            </Item>
            <Item
                disabled={source.isCreate === 2 || source.status === '3'}
                key={1}>
                {intl.get('projectSpace.disbanded')}
            </Item>
            <Item disabled={source.isCreate === 1} key={2}>
                {intl.get('projectSpace.exit')}
            </Item>
        </Menu>
    );

    const FOOTER = {
        1: (
            <Form.Item label={intl.get('projectSpace.expireDate')}>
                {source.expireDateMax &&
                    dayjs(source.expireDateMax).format('YYYY-MM-DD')}
            </Form.Item>
        ),
        3: (
            <>
                <div className="orange-item">
                    {intl.get('projectSpace.unpaidAmount', {
                        num: paymentAmount,
                    })}
                </div>
                <div className="orange-btn" onClick={() => toPay?.(source)}>
                    {intl.get('projectSpace.toPay')}
                </div>
            </>
        ),
        4: (
            <>
                <div className="orange-item">
                    {intl.get('userCenter.stale')}
                </div>
                <div className="orange-btn" onClick={() => toPay?.(source)}>
                    {intl.get('userCenter.reOrders')}
                </div>
            </>
        ),
        5: (
            <>
                <Form.Item label={intl.get('projectSpace.expireDate')}>
                    {source.expireDateMax &&
                        dayjs(source.expireDateMax).format('YYYY-MM-DD')}
                </Form.Item>
                {source.isCreate === 1 && (
                    <div className="orange-btn" onClick={() => toPay?.(source)}>
                        {intl.get('userCenter.renew')}
                    </div>
                )}
            </>
        ),
    };

    const createMsg = `${source.username}${intl.get(
        'projectSpace.createTime'
    )}${source.times}`;

    return (
        <div className="project-card1_4">
            <div className="image-wrap">
                {source.div === '2' && (
                    <div className="synergy">
                        {intl.get('projectSpace.synergyProject')}
                    </div>
                )}

                <Image
                    className={`project-image pointer ${
                        source.image ? 'has--image' : ''
                    }`}
                    onClick={() => clickName?.()}
                    src={
                        source.image ||
                        require('&/assets/img/userCenter/lbdefault.png').default
                    }
                    preview={false}></Image>
            </div>
            <div className="project-desc">
                {source.status !== '3' && (
                    <div className="comment">{source.comment}</div>
                )}
                <div className="desc-content">
                    <header
                        className={`project-name text-no-wrap project-name--link`}
                        title={source.name}
                        onClick={() => clickName?.()}>
                        {source.name}
                    </header>
                    <div
                        title={createMsg}
                        className="content-time username-box">
                        <p className="text-no-wrap">{source.username}</p>
                        <span>
                            {intl.get('projectSpace.createTime')}
                            {source.times}
                        </span>
                    </div>
                    <div className="content-item text-no-wrap">
                        {FOOTER[source.status]}
                    </div>
                </div>

                {hasMenu && (
                    <Dropdown overlay={menu}>
                        <EllipsisOutlined className="more-icon" />
                    </Dropdown>
                )}
            </div>
        </div>
    );
}

export default ProjectCard;
